export default "__VITE_ASSET__YMYXO$LV__"